import { onUnmounted } from "vue";

export const BroadcastChannelName = {
  TAB_RELOAD: "tabReloadChannel",
};

export default function useBroadcast() {
  const postBroadcastMessage = (channelName: string, message: string) => {
    const broadcast = new BroadcastChannel(channelName);
    broadcast.postMessage(message);
    broadcast.close();
  };

  const tabReloadEventAttach = () => {
    const broadcast = new BroadcastChannel(BroadcastChannelName.TAB_RELOAD);
    const handleReloadEvent = () => {
      if (document.visibilityState === "hidden") {
        window.location.reload();
        localStorage.setItem("tabReload", "false");
      }
    };
    broadcast.addEventListener("message", handleReloadEvent);

    const unmount = onUnmounted(() => {
      broadcast.removeEventListener("message", handleReloadEvent);
      broadcast.close(); // Close the channel when the component is unmounted
    });

    return unmount; // Return the unmount function
  };

  return {
    postBroadcastMessage,
    tabReloadEventAttach,
  };
}
